// extracted by mini-css-extract-plugin
module.exports = {"phoneWarn":"otp-passcode-entry_phoneWarn__IuCeH","inputContainer":"otp-passcode-entry_inputContainer__8TdW4"};